/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable prefer-named-capture-group */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/hook-use-state */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { API_URL, PREV_DAY_DATE } from "utils/constant";
import httpClient from "utils/apis/http-client";
import { showToast } from "utils/helper";
import { Button, DatePicker, Input } from "@repo/ui";
import { formatDate } from "date-fns";

const apiUrl = API_URL;

function AssetsReturn({ onAssetReturned }: any) {
  const currentDate = new Date();
  const [assets, setAssets] = useState([]);
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [assetNos, setAssetsNos] = useState([]);
  const [selectedAssetNos, setSelectedAssetsNos] = useState([]);

  const [returnDate, setReturnDate] = useState(currentDate);
  const [employeeId, setEmployeeId] = useState("");
  const [txtEmployeeIdColor, setTxtEmployeeIdColor] = useState("");
  const [isValidEmployee, setIsValidEmployee] = useState(false);

  const [btnConfirmText, setBtnConfirmText] = useState("Confirm");
  const [btnConfirmDisabled, setBtnConfirmDisabled] = useState(true);

  const getAssetsList = async (employeeId: any) => {
    const assetsListEndpoint = `${apiUrl}/resources/assets/issued/list/${employeeId}`;

    try {
      await httpClient.get(assetsListEndpoint).then((res) => {
        if (res.status === 200) {
          const result = res.data.map((m: any) => ({
            assetNo: m.assetNo,
            description: m.description,
            assetType: m.assetType,
            serialNo: m.serialNo,
          }));

          setAssets(result);

          setAssetsNos(
            result.map((ast: any) => `${ast.description} (${ast.assetNo})`)
          );
        } else {
          setAssets([]);
          setAssetsNos([]);
          showToast("error", "Unable to load assets.");
        }
      });
    } catch (err) {
      setAssets([]);
      setAssetsNos([]);
      showToast("error", "Unable to load assets.");
    }
  };

  const onTxtReturnDateChanged = (date: Date) => {
    if (date) {
      setReturnDate(date);
    }
  };

  const onAssetSelected = (event: any) => {
    const selections = event.target.value;
    setSelectedAssetsNos(selections);

    const lastItem = selections[selections.length - 1];

    if (lastItem) {
      selections.pop();
      const sameItem = selections.find((value: any) => value === lastItem);
      if (sameItem === undefined) {
        selections.push(lastItem);
      }
    }

    const mappedSelections = selections.map((sel: any) =>
      sel.match(/\((.*)\)/).pop()
    );

    const filteredAssets = assets.filter((m: any) =>
      mappedSelections.includes(m.assetNo)
    );

    setSelectedAssets(filteredAssets);

    if (filteredAssets.length === 0 && isValidEmployee) {
      setBtnConfirmDisabled(true);
    } else {
      setBtnConfirmDisabled(false);
    }
  };

  const verifyEmployeeId = async (e: any) => {
    const employeeId = e.target.value;

    if (!employeeId) return;

    const verifyUserEndpoint = `${apiUrl}/auth/verify/employee/${employeeId}`;

    await httpClient
      .get(verifyUserEndpoint)
      .then((res) => {
        if (res.status === 200) {
          setTxtEmployeeIdColor("text-success");
          getAssetsList(employeeId);

          setIsValidEmployee(true);
          if (selectedAssetNos.length > 0) {
            setBtnConfirmDisabled(false);
          } else {
            setBtnConfirmDisabled(true);
          }
        } else {
          setIsValidEmployee(false);
          setBtnConfirmDisabled(true);
          showToast("error", "Entered employee Id is not correct.");
          setTxtEmployeeIdColor("text-error");
        }
      })
      .catch(() => {
        setIsValidEmployee(false);
        setBtnConfirmDisabled(true);
        showToast("error", "Entered employee Id is not correct.");
        setTxtEmployeeIdColor("text-error");
      });
  };

  const onBtnConfirmClicked = async () => {
    if (selectedAssets.length === 0) {
      showToast("error", "No assets selected");
      return;
    }

    const assignedAssets = selectedAssets.map((ast: any) => ({
      assetNo: ast.assetNo,
    }));

    const assignmentDto = {
      employeeId,
      returnDate: formatDate(
        returnDate || currentDate,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      ),
      assets: assignedAssets,
    };

    const assignmentEndpoint = `${apiUrl}/resources/assets/return`;

    setBtnConfirmDisabled(true);
    setBtnConfirmText("Confirming.....");

    await httpClient
      .post(assignmentEndpoint, assignmentDto)
      .then((res) => {
        if (res.status === 200) {
          setSelectedAssets([]);
          setBtnConfirmText("Confirm");
          showToast("success", "Assets returned successfully!");
          onAssetReturned();
        } else {
          setBtnConfirmDisabled(false);
          setBtnConfirmText("Confirm");
          showToast("error", "Failed to return assets, please try again.");
        }
      })
      .catch(() => {
        setBtnConfirmDisabled(false);
        setBtnConfirmText("Confirm");
        showToast("error", "Failed to return assets, please try again.");
      });
  };

  return (
    <>
      <div className="grid mb-3 gap-4 grid-cols-2">
        <DatePicker
          disabled={(date) => PREV_DAY_DATE > date || PREV_DAY_DATE < date}
          selectedDate={returnDate}
          onSelectDate={onTxtReturnDateChanged}
        />

        <Input
          placeholder="Enter Employee Id to issue asset"
          className={txtEmployeeIdColor}
          value={employeeId}
          onChange={(e) => {
            setEmployeeId(e.target.value);
          }}
          onBlur={verifyEmployeeId}
        />
        <MultiSelect
          data={assetNos}
          value={selectedAssetNos}
          onChange={onAssetSelected}
          className="h-10"
          placeholder="Select employee assets"
        />
      </div>
      <Grid data={selectedAssets}>
        <Column field="description" title="Description" />
        <Column field="assetNo" title="Asset No" />
        <Column field="assetType" title="Asset Type" />
        <Column field="serialNo" title="Serial No" />
      </Grid>
      <Button
        variant="secondary"
        className="mt-5 flex ml-auto"
        disabled={btnConfirmDisabled}
        onClick={onBtnConfirmClicked}
      >
        {btnConfirmText}
      </Button>
    </>
  );
}

export default AssetsReturn;
